import { render, staticRenderFns } from "./ServiceAdmin.vue?vue&type=template&id=27a80ace&scoped=true&"
import script from "./ServiceAdmin.vue?vue&type=script&lang=js&"
export * from "./ServiceAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAdmin.vue?vue&type=style&index=0&id=27a80ace&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a80ace",
  null
  
)

export default component.exports